module.exports = __webpack_public_path__ + "img/epr@2x.d60ce93c.jpg";